import { useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../../components/Layout/Layout';
import { Chat } from '../../containers/Chat/Chat';

export const ChatMessagesFromHoldingStatement = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleDots = () => {
    navigate(`/message-details/${id}/fromHoldingStatement`);
  };

  return (
    <Layout
      isMessageLayout
      message="coalert_messages_title"
      to={'/holding-statement'}
      showDots
      dotsCallBack={handleDots}
    >
      <Chat id={id ?? ''} setSubMessage fromHoldingStatment={true} />
    </Layout>
  );
};
